"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * A component that displays a status icon inside a tooltip
 *
 * This is a UI-only component that doesn't contain business logic.
 * The parent component should determine which icon, style, and text to display.
 */
var StatusIconTooltip = function StatusIconTooltip(_ref) {
  var iconClassName = _ref.iconClassName,
      tooltipText = _ref.tooltipText,
      _ref$iconStyle = _ref.iconStyle,
      iconStyle = _ref$iconStyle === void 0 ? {} : _ref$iconStyle;
  // If tooltipText is null or empty, hide from screen readers
  var ariaHidden = !tooltipText;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('tooltip', 'tooltip--day', 'tooltip--thread-type'),
    title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : undefined,
    "aria-hidden": ariaHidden ? 'true' : undefined
  }, (0, _preact.h)("div", {
    className: "js-tooltip-trigger",
    "aria-haspopup": !ariaHidden
  }, (0, _preact.h)("i", {
    className: (0, _classnames.default)('icon--auto-width', iconClassName),
    style: iconStyle,
    "aria-hidden": "true"
  })));
};

var _default = StatusIconTooltip;
exports.default = _default;